// extracted by css-extract-rspack-plugin
export default {"hoverTarget":"oj4PT","defaultIcon":"Fuvtk","hoverParent":"ADsUn"};